export default __webpack_public_path__ + "static/media/wizardAnimation.3713468c.gif";